<template>
  <div class="new-layout" v-scroll-top-on-img>
    <div class="new-layout-bg">
      <div class="header-layout" v-if="!isWX()">
        <div class="back-layout">
          <img @click="back()" class="back" src="@/assets/news_back.png">
        </div>
        <div class="header-layout-title">详情</div>
      </div>
      <div class="new-content" :style="{paddingTop:(statusBarHeight)+ 'px'}">
        <div  class="title">从地平线到塔哈：一份早餐的温度 </div>
        <div class="content">
          <div class="ds-ct">
            清晨的大凉山，薄雾还未完全散尽，塔哈村小学的厨房已飘出阵阵暖香。2025年6月2日，由“广州地平线爱心公益”捐赠的专项善款已落实到位（收款人：许定奎校长），化作了孩子们手中一份份珍贵的爱心早餐。
          </div>
          <img class="new-icon" src="@/assets/news_image3.jpg">
          <div class="ds-ct">
            开餐了！孩子们排着整齐的队伍走向老师，小脸上洋溢着纯真的期待，清澈的眼眸里盛满了期待与雀跃。一个个热气腾腾蓬松的白面馒头、还有一枚枚温热的煮鸡蛋被依次分发到他们手中。

          </div>
          <img class="new-icon" src="@/assets/news_image4.jpg">
          <div class="ds-ct">
            在教室里，孩子们迫不及待又小心翼翼地享用起来，看见他们一个个小脸上漾开纯真的笑容，那鸡蛋的热度，似乎能暖到心底；那馒头的麦香，仿佛这是世间是朴实的幸福滋味。
          </div>
          <img class="new-icon" src="@/assets/news_image5.jpg">
          <div class="ds-ct">
            许定奎校长静静看着这一幕，眼含欣慰。这简单的鸡蛋与馒头，承载着远方沉甸甸的关怀，它们不仅填饱了孩子们的肚子，更驱散了山区的微寒，让希望像这清晨的阳光一样，暖暖地照进每一个幼小的心灵。这一刻，塔哈的清晨，因这份实在的温暖而无比明亮，孩子们眼中闪烁的光，就是公益路上最美的回响。
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      statusBarHeight: 60,
    };
  },

  methods: {

    isWX() {
      var userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf('micromessenger') !== -1) {
        this.statusBarHeight = 0;
        return true;
      } else {
        this.statusBarHeight = 60;
        return  false;
      }
    },
    back() {
      window.history.back(-1);
    },
  },
  mounted() {


  },
};

</script>

<style lang="scss" scoped>
.new-layout {

  position: relative;

  .new-layout-bg {
    background: #F0F4FF;
  }


  .correlation-new {
    background: #ffffff;
    padding: 10px;
    padding-bottom: 0;
    margin-top: 10px;


    .correlation-new-title {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      padding-top: 6px;
      //padding-bottom: 14px;
      font-size: 18px;
      font-weight: 500;
      color: #333333;

      .mark-view {
        height: 19px;
        width: 2px;
        border-radius: 5px;
        background: #3E74F8;
      }

      .dels {
        margin-left: 6px;
      }
    }
  }

  .new-content {

    background: #ffffff;
    color: #333333;
    padding-left: 12px;
    padding-right: 12px;
    padding-top: 12px;
    font-size: 15px;


    .content {
      padding-top: 16px;
      padding-bottom: 16px;
      letter-spacing: 0;
      line-height: 26px;
      text-align: justify;

      .smi-ds{
        font-weight: 400;
      }

      .ds-ct{
        padding-top: 5px;
        padding-bottom: 5px;
        text-align: justify;
      }
      .big-ds{
        padding-top: 5px;
        padding-bottom: 5px;
        text-align: justify;
        font-weight: bold;
        font-size: 18px;
      }
      .mid-ds{
        padding-top: 5px;
        padding-bottom: 5px;
        text-align: justify;
        font-weight: bold;
      }

      .new-icon {
        width: 100%;
        border-radius: 10px;
        padding-top: 12px;
        padding-bottom: 12px;
      }

    }

    .title {
      text-align: left;
      font-size: 22px;
      font-weight: bold;
    }

  }

  .header-layout {
    background: #ffffff;

    position: fixed;
    height: 44px;
    z-index: 100;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .header-layout-title {
      font-size: 17px;
      color: #000000;
      height: 44px;
      line-height: 44px;
      text-align: center;
      width: 100%;
    }

    .back-layout {
      position: absolute;
      bottom: 0;
      left: 15px;
      height: 44px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      .back {
        width: 20px;
      }
    }
  }
}
</style>
